// Hook for scroll synchronization
import { useCallback } from "react";

/**
 * Hook for table scroll synchronization
 */
const useScrollSync = (beforeTableRef, afterTableRef) => {
  const handleTableScroll = useCallback(
    (isBeforeTable) => {
      return (event) => {
        const sourceRef = isBeforeTable ? beforeTableRef : afterTableRef;
        const targetRef = isBeforeTable ? afterTableRef : beforeTableRef;

        if (sourceRef.current && targetRef.current) {
          // Synchronize both vertical and horizontal scroll
          targetRef.current.scrollTop = sourceRef.current.scrollTop;
          targetRef.current.scrollLeft = sourceRef.current.scrollLeft;
        }
      };
    },
    [beforeTableRef, afterTableRef]
  );

  return {
    handleTableScroll,
  };
};

export default useScrollSync;
